"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelStateEdit = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var observable_map_1 = require("../util/observable.map");
var CollectionModelStateEdit = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelStateEdit, _super);
    function CollectionModelStateEdit(state) {
        var _this = _super.call(this, state) || this;
        _this.fields = new observable_map_1.ObservableIMap();
        _this.geometries = new observable_map_1.ObservableIMap();
        return _this;
    }
    CollectionModelStateEdit.prototype.reset = function () {
        _super.prototype.reset.call(this);
    };
    CollectionModelStateEdit.prototype.setFieldValue = function (fieldId, state) {
        _super.prototype.setFieldValue.call(this, fieldId, state);
    };
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionModelStateEdit.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionModelStateEdit.prototype, "setFieldValue", null);
    return CollectionModelStateEdit;
}(core_shared_1.CollectionModelStateProxy));
exports.CollectionModelStateEdit = CollectionModelStateEdit;
//# sourceMappingURL=collection.edit.model.js.map